

import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import { ApiUrl } from "../../Constants/Weburl";
import "../../CssPage/Livesettings.css";
import SettingSidebar from "../../components/Setttingsidebar";
import CustomCard from "../../components/CustomCard";
import Custominput from '../../components/Custominput';
import { getAdminSettings, saveAdminSettings } from "../../services/reactapis";
import Layout from "../../components/Layout";
import SettingsPageShell from "../../components/SettingsMenu";

export default function AdminSettings() {

    const [settings, setSettings] = useState(null);
    const [title, setTitle] = useState("");

    const [favicon, setFavicon] = useState(null);
    const [logoDark, setLogoDark] = useState(null);
    const [logoLight, setLogoLight] = useState(null);

    const [faviconPreview, setFaviconPreview] = useState("");
    const [logoDarkPreview, setLogoDarkPreview] = useState("");
    const [logoLightPreview, setLogoLightPreview] = useState("");

    const [saving, setSaving] = useState(false);
    const [saved, setSaved] = useState(false);

      const [loading, setLoading] = useState(true);
    

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {

            const token = localStorage.getItem("adminToken");

            const response = await getAdminSettings(token);

            console.log("ADMIN SETTINGS:", response);

            if (response?.success) {

                const data = response.data;

                setTitle(data?.title || "");

                // if (data?.favicon) {
                //     setFaviconPreview(
                //         `${ApiUrl}admin-settings/${data.favicon}`
                //     );
                // }

                if (data?.favicon) {

                    const faviconUrl =
                        `${ApiUrl}admin-settings/${data.favicon}`;

                    setFaviconPreview(faviconUrl);

                    let faviconLink = document.querySelector(
                        "link[rel='icon']"
                    );

                    if (!faviconLink) {
                        faviconLink = document.createElement("link");

                        faviconLink.rel = "icon";

                        document.head.appendChild(faviconLink);
                    }

                    faviconLink.href = faviconUrl;
                }

                if (data?.logo_dark) {
                    setLogoDarkPreview(
                        `${ApiUrl}admin-settings/${data.logo_dark}`
                    );
                }

                if (data?.logo_light) {
                    setLogoLightPreview(
                        `${ApiUrl}admin-settings/${data.logo_light}`
                    );
                }
            }

        } catch (error) {
        console.log("FETCH SETTINGS ERROR:", error);
        } finally{
            setLoading(false);
        }
    };

    const handleFaviconChange = (e) => {
        const file = e.target.files[0];

        if (!file) return;

        setFavicon(file);

        const previewUrl = URL.createObjectURL(file);

        setFaviconPreview(previewUrl);

        // Browser tab favicon change
        let faviconLink = document.querySelector(
            "link[rel='icon']"
        );

        if (!faviconLink) {
            faviconLink = document.createElement("link");
            faviconLink.rel = "icon";
            document.head.appendChild(faviconLink);
        }

        faviconLink.href = previewUrl;
    };

    //dark logo
    const handleLogoDarkChange = (e) => {

        const file = e.target.files[0];

        if (!file) return;

        setLogoDark(file);

        setLogoDarkPreview(
            URL.createObjectURL(file)
        );
    };

    //lightlogo
    const handleLogoLightChange = (e) => {

        const file = e.target.files[0];

        if (!file) return;

        setLogoLight(file);

        setLogoLightPreview(
            URL.createObjectURL(file)
        );
    };


    //save api
    const handleSave = async () => {

        try {

            setSaving(true);

            const token = localStorage.getItem("adminToken");

            const formData = new FormData();

            formData.append("title", title);

            if (favicon) {
                formData.append("favicon", favicon);
            }

            if (logoDark) {
                formData.append("logo_dark", logoDark);
            }

            if (logoLight) {
                formData.append("logo_light", logoLight);
            }

            console.log("FORM DATA:", formData);

            const response = await saveAdminSettings(
                token,
                formData
            );

            console.log("SAVE RESPONSE:", response);

            if (response?.success) {

                alert("Admin settings Created successfully");

                // Refresh latest data
                // fetchSettings();
            }

        } catch (error) {

            console.log("SAVE ERROR:", error);

            alert(
                error.response?.data?.message ||
                "Failed to update admin settings"
            );

        } finally {

            setSaving(false);

        }
    };

    return (
               <Layout>
               <SettingsPageShell wrapperClassName="rr-wrapper-adminsetting">
                        
                        {loading ? (
                    <div className="ls-wrapper-adminsetting">
                        <p>Loading...</p>
                    </div>
                ) : (
           
                        <div className="ls-wrapper-adminsetting">

                            {/* ── Admin Setting Section ── */}
                            <div className="ls-section-title">Admin Settings</div>

                            <div className="ls-grid-3">

                                <CustomCard className="ls-card">
                                    {/* <label className="ls-label">
                               Title
                            </label> */}
                                    {/* <input */}
                                    <Custominput
                                        label="Title"
                                        labelClassName="ls-label"
                                        type="text"
                                        className="ls-input"
                                        placeholder="Enter Title"
                                        value={title}
                                        // onChange={(e) =>
                                        //     setSettings({ ...settings, title: e.target.value, })
                                        // }
                                        onChange={(e) => setTitle(e.target.value)}
                                    />
                                </CustomCard>

                                <CustomCard className="ls-card">
                                    {/* <label className="ls-label">
                              Favicon
                            </label>
                            <input */}
                                    <Custominput
                                        label="Favicon"
                                        labelClassName="ls-label"
                                        type="file"
                                        accept="image/*"
                                        className="ls-input"
                                        // onChange={(e) =>
                                        //     setSettings({
                                        //         ...settings,
                                        //         file: e.target.files[0],
                                        //     })
                                        // }
                                        onChange={handleFaviconChange}
                                    // onChange={(e) => setFavicon(e.target.files[0])}
                                    />
                                    {faviconPreview && (
                                        <div className="image-preview favicon-preview">
                                            <img
                                                src={faviconPreview}
                                                alt="Favicon"
                                                width="80"
                                                height="80"
                                            />
                                        </div>
                                    )}
                                </CustomCard>

                                <CustomCard className="ls-card">
                                   
                                    <Custominput
                                        label="Logo (Dark)"
                                        labelClassName="ls-label"
                                        type="file"
                                        accept="image/*"
                                        className="ls-input"
                                      
                                        onChange={handleLogoDarkChange}
                                    />
                                    {logoDarkPreview && (
                                        <div className="image-preview">
                                            <img
                                                src={logoDarkPreview}
                                                alt="Dark Logo"
                                                style={{
                                                    maxWidth: "200px",
                                                    maxHeight: "100px",
                                                    objectFit: "contain",
                                                }}
                                            />
                                        </div>
                                    )}
                                </CustomCard>

                                <CustomCard className="ls-card">
                                    {/* <label className="ls-label">
                                        Logo (Light)
                                    </label>
                                    <input */}
                                    <Custominput
                                        label="Logo (Light)"
                                        labelClassName="ls-label"
                                        type="file"
                                        accept="image/*"
                                        className="ls-input"
                                        // onChange={(e) =>
                                        //     setSettings({
                                        //         ...settings,
                                        //         file: e.target.files[0],
                                        //     })
                                        // }
                                        onChange={handleLogoLightChange}
                                    // onChange={(e) => setLogoLight(e.target.files[0])}
                                    />

                                    {logoLightPreview && (
                                        <div className="image-preview">
                                            <img
                                                src={logoLightPreview}
                                                alt="Light Logo"
                                                style={{
                                                    maxWidth: "200px",
                                                    maxHeight: "100px",
                                                    objectFit: "contain",
                                                }}
                                            />
                                        </div>
                                    )}
                                </CustomCard>

                                <button
                                    type="button"
                                    className="ls-save-btn"
                                    onClick={handleSave}
                                    disabled={saving}
                                >
                                    {saving ? "Saving..." : "Save"}
                                </button>

                            </div>


                        </div>
                )}
                </SettingsPageShell>
                </Layout>
          
    );
}
